class City {
  constructor(cityData = {}) {
    this.id = cityData.id || null;
    this.name = cityData.name || "";
  }
}

export default City;
